(function($) {
    $.fn.autogrow = function() {
        return this.each(function() {
            var $this = $(this);
            
            function updateHeight() {
                $this.css('height', 'auto');
                $this.css('height', this.scrollHeight + 'px');
            }

            // Initial height update
            updateHeight();

            // Bind input event
            $this.off('input.autogrow').on('input.autogrow', updateHeight);
        });
    };
}(jQuery));
